import LegalLayoutPage from "./LegalLayoutPage";

export default LegalLayoutPage